import Raven from "raven-js";

// fonction d'initialisation du logger (sentry)
export default function registerLogger(): void {
  if (import.meta.env.PROD) {
    const environment = import.meta.env.REACT_APP_ENVIRONMENT || import.meta.env.NODE_ENV;

    const sentryURL = import.meta.env.REACT_APP_SENTRY_URL;
    if (sentryURL) {
      // configuration de sentry
      Raven.config(sentryURL, {
        release: import.meta.env.REACT_APP_VERSION,
        environment: environment
      }).install();
    }
  }
}
